export class Color {
    public static readonly BLACK = new Color(0, 0, 0);
    public static readonly RED = new Color(255, 0, 0);
    public static readonly GREEN = new Color(0, 255, 0);
    public static readonly YELLOW = new Color(255, 255, 0);
    public static readonly BLUE = new Color(0, 0, 255);
    public static readonly MAGENTA = new Color(255, 0, 255);
    public static readonly CYAN = new Color(0, 255, 255);
    public static readonly WHITE = new Color(255, 255, 255);
    public static readonly GRAY = new Color(128, 128, 128);
    public static readonly LIGHTGRAY = new Color(192, 192, 192);
    public static readonly DARKRED = new Color(128, 0, 0);
    public static readonly DARKGREEN = new Color(0, 128, 0);
    public static readonly DARKBLUE = new Color(0, 0, 128);
    public static readonly ORANGE = new Color(255, 200, 0);
    public static readonly PINK = new Color(255, 175, 75);
    public static readonly PURPLE = new Color(128, 0, 255);
    public static readonly BROWN = new Color(153, 102, 0);

    //

    /**
     * Colors of XLogo
     *
     * The order of this array matters. A Color can be referenced using number from 0 - 16.
     * We directly use this number to index the color within this array, which is not the best idea
     * but we did not find a better solution in time.
     */
    private static readonly colorNumberMapping: Color[] = [
        Color.BLACK,
        Color.RED,
        Color.GREEN,
        Color.YELLOW,
        Color.BLUE,
        Color.MAGENTA,
        Color.CYAN,
        Color.WHITE,
        Color.GRAY,
        Color.LIGHTGRAY,
        Color.DARKRED,
        Color.DARKGREEN,
        Color.DARKBLUE,
        Color.ORANGE,
        Color.PINK,
        Color.PURPLE,
        Color.BROWN,
    ];

    public static lookupColor(value: string | number): Color | undefined {
        // I did not find a better solution to handle lookup of string and number nicely
        if (typeof value === "string") {
            switch (value) {
                case "black":
                    return Color.BLACK;
                case "red":
                    return Color.RED;
                case "green":
                    return Color.GREEN;
                case "yellow":
                    return Color.YELLOW;
                case "blue":
                    return Color.BLUE;
                case "magenta":
                    return Color.MAGENTA;
                case "cyan":
                    return Color.CYAN;
                case "white":
                    return Color.WHITE;
                case "gray":
                    return Color.GRAY;
                case "lightgray":
                    return Color.LIGHTGRAY;
                case "darkred":
                    return Color.DARKRED;
                case "darkgreen":
                    return Color.DARKGREEN;
                case "darkblue":
                    return Color.DARKBLUE;
                case "orange":
                    return Color.ORANGE;
                case "pink":
                    return Color.PINK;
                case "purple":
                    return Color.PURPLE;
                case "brown":
                    return Color.BROWN;
                default:
                    return undefined;
            }
        } else if (typeof value === "number") {
            return Color.colorNumberMapping[value];
        }
        return undefined;
    }

    constructor(
        private _red: number,
        private _green: number,
        private _blue: number,
    ) {
        // TODO: Throw error if out of range!!
    }

    get red() {
        return this._red;
    }

    get green() {
        return this._green;
    }

    get blue() {
        return this._blue;
    }

    public equals(other: any): boolean {
        if (other instanceof Color) {
            return (
                this.red === other.red &&
                this.green === other.green &&
                this.blue === other.blue
            );
        } else if (typeof other === "number" && isFinite(other)) {
            const convertedColor = Color.lookupColor(other);
            if (convertedColor) {
                return (
                    this.red === convertedColor.red &&
                    this.green === convertedColor.green &&
                    this.blue === convertedColor.blue
                );
            }
        }
        return false;
    }

    public toString(): string {
        return `Color(${this._red},${this._green},${this._blue})`;
    }
}



// WEBPACK FOOTER //
// ./src/app/xlogo-parser/ir/color.ts